import { Badge, Text } from "@chakra-ui/react";
import { ChangeResult, changeRejectionMessages } from "../changes";
import { formatMonth } from "../columns";

type Props = {
  result: ChangeResult;
  scheduledLabel: (month: string) => string;
};

const ChangeOutcome = ({ result, scheduledLabel }: Props): JSX.Element => {
  if (result.outcome === "applied")
    return (
      <Badge bg="#E3FFE4" color="#3CB18B" size="md">
        Aplicado
      </Badge>
    );

  if (result.outcome === "scheduled" && result.effectiveMonth)
    return (
      <Badge bg="#FFF7D6" color="#E6AE22" size="md">
        {scheduledLabel(formatMonth(result.effectiveMonth))}
      </Badge>
    );

  return (
    <Text fontSize="sm" color="#EC5858">
      {result.error
        ? changeRejectionMessages[result.error]
        : "No se pudo aplicar."}
    </Text>
  );
};

export default ChangeOutcome;
